import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable } from 'rxjs';
import { MicrosoftAuthService } from '@services/core/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private http = inject(HttpClient);

  constructor() { }


  get(): Observable<any> {
    return this.http.get(Global.url + 'V1/users');
  }

  create(data: any): Observable<any> {
    return this.http.post(Global.url + 'V1/users', data);
  }

  update(params: any): Observable<any> {
    return this.http.put(Global.url + 'V1/users/' + params.id, params);
  }

  delete(uuid: any): Observable<any> {
    return this.http.delete(Global.url + 'V1/users/' + uuid);
  }

  getParties(): Observable<any> {
    return this.http.get(Global.url + 'V1/parties');
  }

  /** Entidades del rol (user_role_entity). */
  saveRoleEntities(userUuid: string, roleSlug: string | number, entityCodes: number[]): Observable<any> {
    return this.http.put(Global.url + 'V1/users/' + userUuid + '/role-entities', {
      roleSlug,
      roleId: typeof roleSlug === 'number' ? roleSlug : undefined,
      entityCodes
    });
  }
}
